<div class="container super-test" #container>
  <mydocma-split (splitReady)="splitReady($event)" [options]="planListSideAreaOptions"
                 style="width: 100%; height: 100%">
    <mydocma-split-area
      [size]="currentPlanListSize ?? 50"
      [minSize]="0"
      style="width: 100%; height: 100%"
      *ngIf="creationService.creationState === creationStateEnum.Idle || creationService.creationState === creationStateEnum.WaitForPlanSelection"
      [collapsable]="!!mmBimService.selectedPlan"
    >
      <div class="area-1" style="width: 100%; height: 100%;" mydocmaResizeEvent
           (resize)="resizeContainer(container)"
      >
        <mydocma-creation-left-pane-container>

        </mydocma-creation-left-pane-container>
      </div>
    </mydocma-split-area>
    <mydocma-split-area
      [size]="currentPlanListSize ? (100 - currentPlanListSize) : 50"
      [minSize]="0"
      style="width: 100%; height: 100%"
    >
      <!-- todo remove all button to additional component-->
      <div class="area-2" style="width: 100%; height: calc(100% - 53px);">
        <!--         // todo remove to separate component mydocma-section-header-->
        <div class="header mydocma-section-header">
          <div class="creation-info">
            <div class="model-info-header" *ngIf="(mmBimService.defaultBimModel && (!deviceService.isTablet() || !mmBimService.selectedPlan || (screenOrientationService.currentScreenOrientation$ | async) == 1))">
              <mydocma-custom-mat-icon iconName="_bim-model">

              </mydocma-custom-mat-icon>
              <div class="model-info-text">  {{mmBimService.defaultBimModel?.description}}</div>

            </div>
            <div class="plan-info-header" *ngIf="mmBimService.selectedPlan as selectedPlan">
              <mydocma-custom-mat-icon iconName="_plan-view">

              </mydocma-custom-mat-icon>
              <div class="plan-info-text">
                {{selectedPlan?.data.Description}}
              </div>
            </div>
          </div>
          <div class="action-buttons">
            <!--    //back button-->
            <button mat-button class="mydocma-btn cancel-btn mat-stroked-button"
                    *ngIf="creationState !== pinCreationState.Idle && !creationService.objectSelectionBypassed"
                    (click)="back()"
                    [disabled]="creationState !== pinCreationState.PrepareSave"
            >
              <mat-icon>chevron_left</mat-icon>
              {{'MM.general.button.back' | translate}}
            </button>
            <!--    //next step button-->
            <button
              *ngIf="creationState !== pinCreationState.Idle"
              [disabled]="creationState === pinCreationState.EnterCreationMode || creationState === pinCreationState.WaitForPlanSelection"
              mat-stroked-button type="button" class="mydocma-btn-primary next-btn"
              (click)="nextFaultCreation()">
              {{'MM.general.button.next' | translate }}
              <mat-icon>chevron_right</mat-icon>
            </button>
            <!--    new button-->

            <button *ngIf="creationState === pinCreationState.Idle && (permissionNewFault$  | async)" mat-stroked-button
                    type="button"
                    class="mydocma-btn-primary next-btn" (click)="startFaultCreation()">
              {{'MM.general.button.create' | translate }}
              <mat-icon>add</mat-icon>
            </button>
            <button
              [disabled]="!(pinService.selectedPin$ | async)"
              *ngIf="creationState === pinCreationState.Idle" mat-stroked-button
              type="button"
              class="edit-btn" (click)="editFault()">
              <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
              <!--              {{'MM.layout.edit' | translate }}-->
            </button>

            <mat-button-toggle-group *ngIf="creationState === pinCreationState.Idle && (deviceService.isDesktop() || (deviceService.isTablet() && (screenOrientationService.currentScreenOrientation$ | async) == 1))" single [value]="splitOptions.direction" class="splitter-btns">
              <mat-button-toggle
                  [value]="splitterDirectionEnum.Vertical"
                  (click)="toggleSplitterDirection(splitterDirectionEnum.Vertical)"
                  [matTooltip]="'MM.general.button.horizontalSplit' | translate"
                  matTooltipPosition="below"
                  class="splitter-btn">
                <mydocma-custom-mat-icon [iconName]="'_splitter-horizontal'" style="display: inline-flex"></mydocma-custom-mat-icon>
              </mat-button-toggle>
              <mat-button-toggle
                [value]="splitterDirectionEnum.Horizontal"
                (click)="toggleSplitterDirection(splitterDirectionEnum.Horizontal)"
                [matTooltip]="'MM.general.button.verticalSplit' | translate"
                matTooltipPosition="below"
                class="splitter-btn">
              <mydocma-custom-mat-icon [iconName]="'_splitter-vertical'" style="display: inline-flex"></mydocma-custom-mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>

            <!--    cancel button-->
            <button *ngIf="creationState !== pinCreationState.Idle"
                    class="mydocma-dialog-btn cancel-btn mat-stroked-button" (click)="cancelPrepareSave()">
              {{'MM.general.button.cancel' | translate }}
            </button>
            <button class="close-btn" mat-icon-button
                    [matTooltip]="'MM.general.button.closeModelView' | translate"
                    (click)="closeDialog()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

        </div>
        <div #element class="main-content">

          <!--         // todo remove to separate component mydocma-split -->
          <mydocma-split
            [options]="splitOptions" style="height: 100%;" (splitReady)="mainSplitAreaReady($event)">
            <mydocma-split-area
              [minSize]="0"
            >
              <div
                mydocmaResizeEvent (resize)="resizeMain(element)"
                class="bim-viewer-split-area">
                <mydocma-mm-bim-viewer>

                </mydocma-mm-bim-viewer>
              </div>
            </mydocma-split-area>
            <mydocma-split-area
              [minSize]="0"
              *ngIf="mmBimService.selectedPlan$ | async"
            >
              <div class="plan-split-area">
                <mydocma-mm-bim-plan-viewer></mydocma-mm-bim-plan-viewer>
              </div>
            </mydocma-split-area>

          </mydocma-split>

        </div>
      </div>
    </mydocma-split-area>
  </mydocma-split>
</div>
<div class="non-blockable-loader-wrapper" *ngIf="laoderVisibility">
<mydocma-none-blockable-ui-loader></mydocma-none-blockable-ui-loader>
</div>


